import { Component } from '@angular/core';
@Component({
  selector: 'cat-page',
  templateUrl: './page-404.html'
})
export class PagesPage404 { }


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/pages/page-404.page.ts